export default new class Header {
  constructor () {
    this.initEvents();
    this.headerElemMenu = null;
    this.topHeaderElem = null;

  }

  initEvents () {
    const _this = this;
    document.addEventListener("DOMContentLoaded", () => {
      this.eventLoad();
      this.eventResize();
      this.eventScroll();
    });
  }

  eventScroll () {
    this.headerElemMenu = document.querySelector(".menu-drawer .menu-drawer__menu");
    this.overlayElemMenu = document.querySelector(".menu-drawer .menu-drawer__overlay");
    this.topHeaderElem = document.querySelector("#shopify-section-announcement-bar");
    if (!this.topHeaderElem || !this.headerElemMenu) return false;
    document.addEventListener("scroll", () => {
      this.calcHeaderMobileMenu();
    });
  }

  isBlockIsVisible () {
    const domRect = this.topHeaderElem.getBoundingClientRect();
    return domRect.top + domRect.height >= domRect.height;
  };

  calcHeaderMobileMenu () {

    if (this.isBlockIsVisible()) {
      if (this.headerElemMenu.classList.contains("menu-drawer__menu--scroll")) {
        this.headerElemMenu.classList.remove("menu-drawer__menu--scroll");
        this.overlayElemMenu.classList.remove("menu-drawer__overlay--scroll");
      }
    } else {
      if (!this.headerElemMenu.classList.contains("menu-drawer__menu--scroll")) {
        this.headerElemMenu.classList.add("menu-drawer__menu--scroll");
        this.overlayElemMenu.classList.add("menu-drawer__overlay--scroll");
      }
    }
  }

  eventLoad () {
    this.setVaribleTopBlock();
    this.setVaribleHeader();
  }

  eventResize () {
    window.addEventListener("resize", () => {
      this.eventLoad();
    });
  }

  setVaribleStyle (name, value) {
    document.querySelector(":root").style.setProperty(name, value + "px");
  }

  setVaribleTopBlock () {
    const bar = document.querySelector("#shopify-section-announcement-bar");
    this.setVaribleStyle("--size-top-block", bar.clientHeight);
    if (!bar) return;
  }

  setVaribleHeader () {
    const header = document.querySelector("#shopify-section-header-new");
    if (!header) return;
    this.setVaribleStyle("--size-header-height", header.clientHeight);
  }
}();

